// extracted by mini-css-extract-plugin
module.exports = {"header":"NavBar_header__6cQIO","MenuNavBar":"NavBar_MenuNavBar__1-X84","sidebarButton":"NavBar_sidebarButton__2CtPD"};